import { PricingPlanCard, PricingPlanProps } from "./card";

type PricingPlansSectionProps = {
  plans: PricingPlanProps[];
  selectedPricingPlan: number;
  setSelectedPricingPlan: React.Dispatch<React.SetStateAction<number>>;
};

export const PricingPlansSection = ({
  plans,
  selectedPricingPlan,
  setSelectedPricingPlan,
}: PricingPlansSectionProps) => (
  <div className="max-w-md mx-auto space-y-4 lg:max-w-5xl lg:grid lg:grid-cols-2 lg:gap-5 lg:space-y-0 relative">
    {plans.map((pricingPlan, index) => (
      <PricingPlanCard
        isSelected={selectedPricingPlan == index}
        onClick={() => setSelectedPricingPlan(index)}
        key={index}
        {...pricingPlan}
      />
    ))}
  </div>
);
